module.exports = __webpack_public_path__ + "static/img/13.24d1563.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/cooperate/13.png
// module id = 140p
// module chunks = 1